import LocalEntregaModel from "@/models/transporte/localEntregaModel";
import nfetch from "@/utils/events/nfetch";

import { iServiceCached } from "../base/iServiceCached";

class LocalEntregaService extends iServiceCached<LocalEntregaModel> {
    constructor() {
        super("LocalEntrega");
    }

    public async comboCached(franquiaId: number, isEdicao = false) {
        const retorno = await this.combo(franquiaId);
        const locaisFiltrados = isEdicao ? retorno : retorno.filter(p => p.ativo);

        const options = locaisFiltrados.map(p => ({
            value: p.id,
            text: `${!p.ativo ? "[INATIVO] " : ""}${p.codigo} - ${p.descricao}`,
            servicoEntregaId: p.servicoEntregaId,
            codigo: p.codigo,
        }));

        return options;
    }

    public getProximoCodigo(): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetProximoCodigo`, {
            credentials: "same-origin",
        });
    }
}

export default new LocalEntregaService();
